import { ApiError } from '@atlassian/conversation-assistant-service-api/utils/api-error';

export const isForbiddenConversationError = (error: unknown): error is ApiError =>
	error instanceof ApiError && error.errorAttributes?.statusCode === 403;
